// Helper functions
const fetchCalculator = async (productId, isPreview) => {
  try {
    const baseAPI = "https://sticker-junkie-shopify-app-d9c55e68ab12.herokuapp.com";
    const url = isPreview
      ? `${baseAPI}/api/calculator?productId=${productId}&isPreview=true`
      : `${baseAPI}/api/calculator?productId=${productId}`;

    const response = await fetch(url);
    if (!response.ok) throw new Error("Failed to fetch calculators");

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching calculators:", error);
  }
};

const evaluateFormula = (formula, variables) => { 
  const functionBody = `return ${formula};`;
  const result = new Function(...Object.keys(variables), functionBody)(...Object.values(variables));
  return result;
}

window.fetchCalculator = fetchCalculator;
window.evaluateFormula = evaluateFormula;
